<template>
    <InputMask  mask="##/##"
                :guide="true"
                :required="required"
                :label="label"
                :placeholder="Core.Definition.getDefinition('MM/AA')"
                :id="id"
                v-model="dataValue"></InputMask>
</template>

<script>

  import InputMask from './InputMask'
  export default {
      name: 'InputCCExp',
      extends: InputMask,
      components: {
          InputMask
      },
      props: {
          mask: {
              type: String,
              default: ''
          }
      },
      watch: {
      },
      mounted() {
      },
      data: () => {
          return {
              Core: window.Core
          }
      },
      methods: {
      }
  }
</script>